/// <reference types="@angular/localize" />


import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { environment } from './environments/environment';

registerLocaleData(localeBr);


bootstrapApplication(AppComponent, {
  providers: [
    BrowserAnimationsModule,
    ...appConfig.providers, provideAnimationsAsync(),
  ]
}).catch(err => console.error(err));

console.log('ENVIRONMENT BASE PATH:', environment.basePath);
console.log('ENVIRONMENT PRODUCTION:', environment.environment);
